import { render, staticRenderFns } from "./FrequentlyScannedProductPieChart.vue?vue&type=template&id=80b09124&scoped=true"
import script from "./FrequentlyScannedProductPieChart.vue?vue&type=script&lang=js"
export * from "./FrequentlyScannedProductPieChart.vue?vue&type=script&lang=js"
import style0 from "./FrequentlyScannedProductPieChart.vue?vue&type=style&index=0&id=80b09124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b09124",
  null
  
)

export default component.exports